var _ = require('lodash');
var commonContentPlacements = require('swa-app-configuration/common-content-placements');
var commonContentTemplates = require('swa-app-configuration/common-content-templates');
var PlacementFactory = require('swa-content-core/placement-factory');
var WhereWeFlyModalCommand = require('swa-air-core/content/where-we-fly-modal-command');

var placements = _.assign({}, commonContentPlacements, {});
var templates = _.assign({}, commonContentTemplates, {});

PlacementFactory.setPlacements(placements);
PlacementFactory.setPlacementTemplates(templates);

PlacementFactory.setCommands({
    OPEN_WHERE_WE_FLY_MODAL: WhereWeFlyModalCommand
});
